export default __webpack_public_path__ + "static/media/user-icon.641c6d21.png";